import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TCreateRestaurantSelectedItem } from '../../../../../createRestaurantState/createRestaurantContext';
import { useFetchData } from 'hooks/useFetchData';
import { ICurrencies, IGetCurrencies } from 'types';
import { getCurrencies } from 'backend/additionalInformation';
import style from './CurrencySelect.module.scss';

interface ICurrencySelect {
	setCurrencySymbol: (value: TCreateRestaurantSelectedItem) => void;
	setFetchedCurrencies: (value: ICurrencies[]) => void;
}

const CurrencySelect: React.FC<ICurrencySelect> = ({ setCurrencySymbol, setFetchedCurrencies }) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetCurrencies, null>(getCurrencies);
	const { t } = useTranslation('error');

	useEffect(() => {
		response && setFetchedCurrencies(response.data.currencies);
	}, [response]);

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectCurrency') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return response?.data.currencies.map((el) => ({ id: el.isoCurrencySymbol, name: el.isoCurrencySymbol })) || [];
	}, [response]);

	return (
		<FormSelect
			containerClassName={style.select}
			testId="CurrencySelect"
			name="selectedCurrencySymbol"
			label="currencyLabel"
			options={mappedOptions}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setCurrencySymbol}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(CurrencySelect);
